import { render, staticRenderFns } from "./EventForm3Component.vue?vue&type=template&id=09982fa5&"
import script from "./EventForm3Component.vue?vue&type=script&lang=js&"
export * from "./EventForm3Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports